export default {
    name: 'ControlPanel',
    computed: {
        hasDefaultSlot () { // check if the slots are filled to show dropdown or not
            return !!this.$slots.default;
        },
    }
};